import * as React from "react";
import { Grid } from "@mui/material";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";
import "./successPage.css"

const GenesysCloudCredentials = () => {
  const metricsData = React.useMemo(() => {
    try {
      const raw = localStorage.getItem("UiCallRecordingRecords");
      const parsed = JSON.parse(raw || "{}");
      const interactions = Array.isArray(parsed.interactions) ? parsed.interactions : [];

      const agentMap = {};

      interactions.forEach((interaction) => {
        const {
          interactionId,
          queue,
          startTime,
          durationFormatted,
          recordings = [],
          Agent,
        } = interaction;

        const agent = interaction.Agents?.length ? interaction.Agents.join(", ") : Agent || "Unknown Agent";


        recordings.forEach((rec) => {
          if (!agentMap[agent]) agentMap[agent] = [];

          agentMap[agent].push({
            interactionId,
            queue,
            startTime: new Date(startTime).toLocaleString(),
            duration: durationFormatted || "Unknown",
            mediaUrl: rec.s3Url || "",
            recordingId: rec.recordingId || "",
          });
        });
      });

      return agentMap;
    } catch (err) {
      console.error("Error parsing call recordings metrics:", err);
      return {};
    }
  }, []);

  const agentNames = Object.keys(metricsData);
  const [selectedAgent, setSelectedAgent] = React.useState(null);

  const handleAgentClick = (agent) => {
    setSelectedAgent(agent === selectedAgent ? null : agent);
  };

  return (
    <MainTheme>
      <Title title="Call Recording Metrics by Agent" />
      <div className="organization-details-section">
        <Grid container spacing={2} className="container-section">
          <Grid item xs={12}>
            {agentNames.length === 0 ? (
              <p>No metrics available.</p>
            ) : (
              <div style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
                {/* Agent Buttons */}
                <div>
                  <h4>Agents</h4>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {agentNames.map((agent) => (
                      <li
                        key={agent}
                        onClick={() => handleAgentClick(agent)}
                        style={{
                          cursor: "pointer",
                          padding: "10px",
                          marginBottom: "5px",
                          backgroundColor:
                            agent === selectedAgent ? "#d0e0ff" : "#f5f5f5",
                          borderRadius: "5px",
                          fontWeight: agent === selectedAgent,
                          //  ? "bold" : "normal",
                          transition: "background-color 0.2s",
                        }}
                      >
                        {agent}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Recordings Table */}
                {selectedAgent && (
                  <div style={{ flex: 1 }}>
                    <h5>Recordings for: {selectedAgent}</h5>
                    {metricsData[selectedAgent].map((entry, index) => (
                      <table
                        key={index}
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                          marginBottom: "20px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ padding: "8px", fontWeight: "bold",fontSize:'14px' }}>Interaction ID</td>
                            <td style={{ padding: "8px" ,fontSize:'14px'}}>{entry.interactionId}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "8px", fontWeight: "bold",fontSize:'14px' }}>Queue</td>
                            <td style={{ padding: "8px",fontSize:'14px' }}>{entry.queue}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "8px", fontWeight: "bold",fontSize:'14px' }}>Start Time</td>
                            <td style={{ padding: "8px",fontSize:'14px' }}>{entry.startTime}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "8px", fontWeight: "bold",fontSize:'14px' }}>Duration</td>
                            <td style={{ padding: "8px" ,fontSize:'14px'}}>{entry.duration}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "8px", fontWeight: "bold" ,fontSize:'14px'}}>Recording 🔊</td>
                            <td style={{ padding: "8px" ,fontSize:'14px'}}>
                              {entry.mediaUrl ? (
                                <audio
                                  key={entry.recordingId}
                                  controls
                                  onPlay={(e) => {
                                    document.querySelectorAll("audio").forEach((audioEl) => {
                                      if (audioEl !== e.target) {
                                        audioEl.pause();
                                      }
                                    });
                                  }}
                                >
                                  <source src={entry.mediaUrl} type="audio/mpeg" />
                                  Your browser does not support the audio element.
                                </audio>

                              ) : (
                                "Not available"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                  </div>
                )}
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default GenesysCloudCredentials;
